"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var NumbersOutlineIcon = /*#__PURE__*/function (_React$Component) {
  function NumbersOutlineIcon() {
    _classCallCheck(this, NumbersOutlineIcon);
    return _callSuper(this, NumbersOutlineIcon, arguments);
  }
  _inherits(NumbersOutlineIcon, _React$Component);
  return _createClass(NumbersOutlineIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "numbers-outline-icon icon"
      }, /*#__PURE__*/_react["default"].createElement("svg", {
        viewBox: "0 0 74 73"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        fill: "none"
      }, /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(39 38)"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        stroke: "#FFF",
        strokeWidth: "3",
        x: "1.5",
        y: "1.5",
        width: "32",
        height: "32",
        rx: "6"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M17.464 25.288c3.744 0 6.048-2.328 6.048-5.496v-.048c0-3.12-2.232-4.32-4.512-4.704l3.288-3.144c.672-.648 1.104-1.152 1.104-2.064 0-1.008-.792-1.632-1.872-1.632h-8.184c-.864 0-1.584.72-1.584 1.584 0 .864.72 1.584 1.584 1.584h5.16l-3.264 3.288c-.576.576-.792 1.008-.792 1.512 0 .864.72 1.584 1.584 1.584h.576c2.064 0 3.288.768 3.288 2.136v.048c0 1.248-.984 2.04-2.376 2.04-1.32 0-2.328-.432-3.288-1.248-.288-.24-.648-.456-1.176-.456-.96 0-1.776.816-1.776 1.776 0 .528.288 1.032.624 1.32 1.368 1.176 3.168 1.92 5.568 1.92Z",
        fill: "#FFF"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(0 38)"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        stroke: "#FFF",
        strokeWidth: "3",
        x: "1.5",
        y: "1.5",
        width: "32",
        height: "32",
        rx: "6"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M12.032 23.248c0 1.104.84 1.752 1.992 1.752h9.12c.888 0 1.608-.696 1.608-1.584 0-.888-.72-1.608-1.608-1.608h-5.856l2.736-2.112C23 17.392 24.44 16 24.44 13.192v-.048c0-3.144-2.304-5.184-5.784-5.184-2.544 0-4.128.912-5.472 2.472a1.849 1.849 0 0 0-.432 1.152c0 .936.744 1.68 1.68 1.68.576 0 1.008-.264 1.248-.528.936-1.008 1.68-1.464 2.736-1.464 1.32 0 2.256.768 2.256 2.184 0 1.392-.816 2.328-2.904 4.032L12.992 21.4c-.624.504-.96 1.128-.96 1.848Z",
        fill: "#FFF"
      })), /*#__PURE__*/_react["default"].createElement("g", {
        transform: "translate(20)"
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        stroke: "#FFF",
        strokeWidth: "3",
        x: "1.5",
        y: "1.5",
        width: "32",
        height: "32",
        rx: "6"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M16.272 23.32a1.823 1.823 0 1 0 3.648 0V9.784a1.823 1.823 0 0 0-1.824-1.824h-.048c-.504 0-1.032.12-1.728.312l-2.376.696c-.744.216-1.224.84-1.224 1.584 0 .864.744 1.584 1.608 1.584.192 0 .456-.048.648-.096l1.296-.336V23.32Z",
        fill: "#FFF"
      })))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _icon_wrapper["default"])(NumbersOutlineIcon);